import { Badge, Skeleton } from "@mantine/core";
import { useEffect } from "react";
import { useStatusStore } from "@utils/stores/useStatusStore.ts";
import { useTagStore } from "@utils/stores/useTagStore";
import FilterChipsGroup from "../FilterChipsGroup/FilterChipsGroup.tsx";
import FilterChip from "../FilterChip/FilterChip.tsx";

const TagFilterChips = () => {
  const { businessTags, loading, initialized, initialize } = useTagStore();
  const { clickedTags, setClickedTags } = useStatusStore();

  // Initialize tag store on mount
  useEffect(() => {
    if (!initialized && !loading) {
      initialize().catch((error) => {
        console.error("Failed to initialize tags:", error);
      });
    }
  }, [initialized, loading, initialize]);

  const handleTagClick = (tagId: string) => {
    const isCurrentlyChecked = clickedTags.includes(tagId);
    setClickedTags(
      isCurrentlyChecked
        ? clickedTags.filter((id) => id !== tagId)
        : [...clickedTags, tagId]
    );
  };

  if (loading || !initialized) {
    return (
      <FilterChipsGroup data-testid="tag-filter-chips-loading">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} height={36} width={100} radius="xl" />
        ))}
      </FilterChipsGroup>
    );
  }

  if (businessTags.length === 0) {
    return null;
  }

  return (
    <FilterChipsGroup data-testid="tag-filter-chips">
      {businessTags.map((tag) => {
        const isActive = clickedTags.includes(tag.id);

        const icon = (
          <Badge
            size="sm"
            radius="sm"
            style={{
              backgroundColor: isActive ? "rgba(255,255,255,0.3)" : tag.color,
              color: "white",
              border: "none",
              padding: "2px 6px",
            }}
          >
            {tag.name.charAt(0).toUpperCase()}
          </Badge>
        );

        return (
          <FilterChip
            key={tag.id}
            isActive={isActive}
            color={tag.color}
            icon={icon}
            onChange={() => handleTagClick(tag.id)}
            data-testid={`tag-chip-${tag.id}`}
            customStyles={{
              label: {
                paddingTop: "4px",
                paddingBottom: "4px",
                gap: "8px",
              },
            }}
          >
            {tag.name}
          </FilterChip>
        );
      })}
    </FilterChipsGroup>
  );
};

export default TagFilterChips;
